import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import { IoArrowBackSharp } from "react-icons/io5";
import CoinImage from "../../assets/images/coin.png";

export const BetHistory = (props) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [paginatedData, setPaginatedData] = useState([]);
  const [next, setNext] = useState(false);
  const [prev, setPrev] = useState(false);
  const itemPerPage = 10;
  // let start = 1;
  // let end = 4;
  const [start, setStart] = useState(1);
  const [end, setEnd] = useState(4);

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const [allPage, setAllPage] = useState([]);

  useEffect(() => {
    if (totalPages) {
      const n = totalPages;
      const arr = Array.from({ length: n }, (_, i) => i + 1);
      setAllPage(arr);
    
    }
  }, [totalPages]);


  function getPagination(currentPage, totalPages, visiblePages = 3) {
    const half = Math.floor(visiblePages / 2);
    let start = Math.max(1, currentPage - half);
    let end = start + visiblePages - 1;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - visiblePages + 1);
    }

    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return {
      pages,
      hasPrev: currentPage > 1,
      hasNext: currentPage < totalPages,
    };
  }

  const { pages, hasPrev, hasNext } = getPagination(currentPage, totalPages);


  useEffect(() => {
    
    setTotalPages(Math.ceil(props.data.length / itemPerPage));
    setPaginatedData(props.data.slice(indexOfFirstItem, indexOfLastItem));
  }, [props.data, currentPage]);

  // Page Change Handler
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    
  };

  return (
    <>
      <div
        id="extralarge-modal"
        tabIndex="-1"
        className="flex justify-center fixed top-0 left-[25%] right-0 mt-4 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 max-h-full"
      >
        <div
          className="relative w-full max-w-9xl max-h-full bg-181D29 mt-4 left-[25%] left-1/4"
          style={{ left: "25% !important", top: "10% !important" }}
        >
          <div className="bg-181D29 relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
            <div style={{
              width: "74%",
            
              display: "flex",
              justifyContent: "space-between"
            }} className="flex items-center p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
              <div>
                <button
                  type="button"
                  className="text-gray-400 bg-transparent rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                  data-modal-hide="extralarge-modal"
                  onClick={() => props.setOpenBetHistory(false)}
                >
                  <IoArrowBackSharp size={20} />
                </button>
              </div>
              <div>
                <nav>
                  <ul className="flex space-x-2">
                    <li
                     onClick={() => hasPrev && setCurrentPage(currentPage - 1)}
                      className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500  m-1 bg-262E3A`}
                      disabled={currentPage === 1}
                      style={{
                        padding: "5px 10px",
                        cursor: currentPage === 1 ? "not-allowed" : "pointer",
                      }}
                    >
                      <span className="sr-only">Previous</span>
                      <svg
                        className="w-2.5 h-2.5 rtl:rotate-180"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 6 10"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 1 1 5l4 4"
                        />
                      </svg>
                    </li>

                    {/* <li
                      className={`cursor-pointer ${
                        !hasPrev ? "opacity-50 cursor-not-allowed" : ""
                      }`}
                      onClick={() => hasPrev && setCurrentPage(currentPage - 1)}
                    >
                      <span className="sr-only">Previous</span>
                      <svg
                        className="w-2.5 h-2.5 rtl:rotate-180"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 6 10"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 1 1 5l4 4"
                        />
                      </svg>
                    </li> */}

                    {pages.map((page) => (
                      <li
                        key={page}
                        className={`flex items-center justify-center px-3 h-8 leading-tight font-bold cursor-pointer m-1 ${
                          page === currentPage
                            ? "bg-00E701 text-white"
                            : "bg-262E3A text-white"
                        }`}
                        onClick={() => setCurrentPage(page)}
                      >
                        {page}
                      </li>
                    ))}

<li
                      onClick={() => hasNext && setCurrentPage(currentPage + 1)}
                      className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500  m-1 bg-262E3A`}
                      disabled={currentPage === 1}
                      style={{
                        padding: "5px 10px",
                        cursor: currentPage === 1 ? "not-allowed" : "pointer",
                      }}
                    >
                      <span className="sr-only">Next</span>
                      <svg
                        className="w-2.5 h-2.5 rtl:rotate-180"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 6 10"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="m1 9 4-4-4-4"
                        />
                      </svg>
                    </li>


                   
                  </ul>
                </nav>

                {/* <nav aria-label="Page navigation example">
                  <ul className="flex items-center  h-8 text-sm">
                   
                    <li
                      onClick={() => {
                        setPrev(!prev);
                        // setCurrentPage((prev) => Math.max(prev - 1, 1))
                      }}
                      className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500  m-1 bg-262E3A`}
                      disabled={currentPage === 1}
                      style={{
                        padding: "5px 10px",
                        cursor: currentPage === 1 ? "not-allowed" : "pointer",
                      }}
                    >
                      <span className="sr-only">Previous</span>
                      <svg
                        className="w-2.5 h-2.5 rtl:rotate-180"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 6 10"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 1 1 5l4 4"
                        />
                      </svg>
                    </li>
                   
                    {Array.from({ length: end - start + 1 }, (page, index) => {
                      return (
                        <li
                          key={index + 1}
                          className={`flex items-center justify-center px-3 h-8 leading-tight font-bold cursor-pointer m-1 ${
                            start + index + 1 == currentPage
                              ? "bg-00E701 text-white"
                              : "bg-262E3A text-white"
                          } `}
                          onClick={() => handlePageChange(start + index + 1)}
                        >
                          {start + index}
                        </li>
                      );
                    })}
                    <li
                      onClick={() => {
                        setNext(!next);
                        // setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                      }}
                      className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 cursor-pointer m-1 bg-262E3A`}
                      disabled={currentPage === totalPages}
                      style={{
                        padding: "5px 10px",
                        cursor:
                          currentPage === totalPages
                            ? "not-allowed"
                            : "pointer",
                      }}
                    >
                      <span className="sr-only">Next</span>
                      <svg
                        className="w-2.5 h-2.5 rtl:rotate-180"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 6 10"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="m1 9 4-4-4-4"
                        />
                      </svg>
                    </li>
                  </ul>
                </nav> */}
              </div>
            </div>

            <div className="p-4 md:p-5 space-y-4 bg-181D29">
              <div className="pt-4 pb-4">
                {
                  <>
                    <div className="relative overflow-x-auto">
                      <table className="w-full text-sm text-left rtl:text-right text-gray-200 ">
                        <thead className="text-xs text-A5ABAD bg-202531">
                          <tr>
                            <th
                              scope="col"
                              className="px-6 py-3 rounded-s-lg min-w-[150px]"
                            >
                              Game
                            </th>
                            <th
                              scope="col"
                              className="px-6 py-3 rounded-e-lg min-w-[150px]"
                            >
                              Time
                            </th>
                            <th
                              scope="col"
                              className="px-6 py-3 rounded-e-sm min-w-[150px]"
                            >
                              Bet Amount
                            </th>
                            <th
                              scope="col"
                              className="px-6 py-3 rounded-e-lg min-w-[100px]"
                            >
                              Multiplier
                            </th>
                            <th
                              scope="col"
                              className="px-6 py-3 rounded-e-lg min-w-[150px]"
                            >
                              Win Amount
                            </th>
                            <th
                              scope="col"
                              className="px-6 py-3 rounded-e-lg min-w-[100px]"
                            >
                              Profit
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginatedData?.map((itm, index) => {
                            return (
                              <tr className="bg-262E3A text-FEFFFF" key={index}>
                                <th
                                  scope="row"
                                  className="px-6 py-4 font-medium text-gray-200 whitespace-nowrap dark:text-white"
                                >
                                  Plinko
                                  {/* {index + 1 + indexOfFirstItem} */}
                                </th>

                                <td className="px-6 py-4">
                                  {moment(itm?.createdAt).format("LLL")}
                                </td>
                                <td className="px-6 py-4 flex">
                                  <p className="w-25">{itm?.betAmount} </p>{" "}
                                  <img
                                    src={CoinImage}
                                    className="text-gray-400 cursor-pointer"
                                  />
                                </td>
                                <td className="px-6 py-4">{itm?.payout}x</td>
                                <td className="px-6 py-4 flex">
                                  <p className="w-25">
                                    {itm?.amount_received.toFixed(2)}
                                  </p>{" "}
                                  <img
                                    src={CoinImage}
                                    className="text-gray-400 cursor-pointer"
                                  />
                                </td>
                                <td className="px-6 py-4">
                                  <p
                                    className={`w-25 ${
                                      (
                                        itm?.amount_received - itm?.betAmount
                                      ).toFixed(2) > 0
                                        ? "text-green-500"
                                        : "text-red-500"
                                    }`}
                                  >
                                    {(
                                      itm?.amount_received - itm?.betAmount
                                    ).toFixed(2)}
                                  </p>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
